import type {ComponentType} from 'react';

import loadable from '@loadable/component';
import React from 'react';
import {createRoutesFromElements, Route} from 'react-router-dom';

import getSharedLoader from '../lib/router/getSharedLoader';
import AppRoutes from './AppRoutes';
import MarketingRoutes from './MarketingRoutes';
import NotFoundPage from './NotFound';

const BaseLayout = loadable(() => import('../layouts/BaseLayout'));
const MarketingLayout = loadable(() => import('../layouts/marketing'));

export default createRoutesFromElements(
  <Route
    Component={BaseLayout as ComponentType}
    loader={getSharedLoader({loadableRoot: BaseLayout})}
  >
    {MarketingRoutes}
    {AppRoutes}
    <Route Component={MarketingLayout as ComponentType}>
      <Route
        Component={NotFoundPage as ComponentType}
        path="*"
      />
    </Route>
  </Route>,
);
